<ng-container *ngIf="contentToBeDisplayed && !isMyPlanCard">
    <!-- Connected Electronics A/B Testing Card (Light & Dark Variants) -->
    <div *ngIf="showNewCardUi" class="cross-sell-card-v2 flex flex-column md:flex-row border-round-xl overflow-hidden"
        [ngClass]="'theme-' + currentTheme">
        <!-- Hero Image -->
        <div class="hero-image-wrapper w-full overflow-hidden flex">
            <img src="assets/images/crosssell-hero.webp" alt="Electronics protection plan"
                class="hero-image w-full h-full block" />
        </div>

        <!-- Card Content Body -->
        <div class="card-content-body p-4 md:p-6 flex flex-column justify-content-center">
            <!-- Eyebrow -->
            <span class="plan-eyebrow text-sm md:text-base font-medium">Electronics protection plan</span>

            <!-- Headline -->
            <h2 class="card-title text-2xl md:text-3xl font-bold my-2 line-height-2">
                One plan.<br>Your everyday tech, covered.
            </h2>

            <!-- Subtitle -->
            <p class="card-description text-sm md:text-base line-height-3 m-0 mb-3 md:mb-4">
                Get repair or replacement when covered devices stop working, including:
            </p>

            <!-- Devices Container -->
            <div class="devices-box pl-4 md:pl-5 pr-3 py-3 border-round-xl mb-3 md:mb-4">
                <div class="devices-list flex flex-wrap gap-4 md:gap-5 row-gap-3 align-items-center">
                    <div class="device-item flex align-items-center gap-2 text-sm md:text-base font-medium">
                        <span class="device-icon icon-tv" aria-hidden="true"></span>
                        <span>TVs</span>
                    </div>

                    <div class="device-item flex align-items-center gap-2 text-sm md:text-base font-medium">
                        <span class="device-icon icon-laptop" aria-hidden="true"></span>
                        <span>Laptops</span>
                    </div>

                    <div class="device-item flex align-items-center gap-2 text-sm md:text-base font-medium">
                        <span class="device-icon icon-tablet" aria-hidden="true"></span>
                        <span>Tablets</span>
                    </div>

                    <div class="device-item flex align-items-center gap-2 text-sm md:text-base font-medium">
                        <span class="device-icon icon-gamepad" aria-hidden="true"></span>
                        <span>Gaming consoles</span>
                    </div>

                    <div class="device-item flex align-items-center gap-2 text-sm md:text-base font-medium">
                        <span class="device-icon icon-print" aria-hidden="true"></span>
                        <span>Printers</span>
                    </div>
                </div>
            </div>

            <!-- Pricing Row -->
            <div class="pricing-row flex align-items-baseline text-sm md:text-base font-medium mb-3 md:mb-4">
                <span>Starting at&nbsp;</span>
                <span class="price-amount text-2xl md:text-3xl font-bold line-height-1">{{
                    crossSellPrice}}</span>
                <span>/mo.†</span>
            </div>

            <!-- CTA Button (PrimeNG p-button per guideline) -->
            <p-button severity="primary" [rounded]="true"
                styleClass="w-full md:w-auto px-4 md:px-5 py-2 md:py-3 text-base font-semibold"
                data-auto-id="cross-sell-more-info-button" label="Get Electronics Protection"
                (click)="learnAboutOffer()">
            </p-button>
        </div>
    </div>

    <!-- Legacy Cross Sell UI (SURGE or CE when card v2 flag is off) -->
    <p-card *ngIf="!showNewCardUi && !isMyPlanCard" class="cross-sell-card">
        <div
            class="cross-sell-container flex flex-column justify-content-center lg:flex-row justify-content-between bg-slate-700 border-round-xl">
            <div class="px-4 pt-4 lg:py-5 lg:col-8">
                <small class="promotional-offer">
                    <i class="pi pi-bolt mr-1"></i>{{ contentToBeDisplayed.title }}
                </small>
                <h2 class="mt-0 mb-2 text-white">{{ contentToBeDisplayed.hint }}</h2>
                <p class="text-sm font-normal text-white">{{ contentToBeDisplayed.description }}</p>
            </div>

            <div class="px-3 pb-4 md:col-6 lg:col-4 lg:py-7">
                <p-button severity="primary" class="mt-4 border-round-md"
                    styleClass="white-space-nowrap text-sm px-3 w-full md:px-4 lg:px-6"
                    data-auto-id="cross-sell-more-info-button" [rounded]="true" label="Learn about this offer"
                    (click)="learnAboutOffer()">
                </p-button>
            </div>
        </div>
    </p-card>
</ng-container>


<!-- My Plan card is shown only once the price is loaded -->
<div *ngIf="contentToBeDisplayed && isMyPlanCard && monthlyCost" class="col-12 mt-1"
    data-auto-id="my-plan-cross-sell-container">
    <p-panel #cePanel [attr.aria-label]="'Electronics coverage panel'" [toggleable]="true" [collapsed]="false"
        collapseIcon="pi pi-angle-down" expandIcon="pi pi-angle-up"
        [toggleButtonProps]="{ 'ariaLabel': 'Electronics coverage panel toggle button' }"
        data-auto-id="my-plan-ce-cross-sell-card">
        <ng-template pTemplate="header">
            <div class="flex w-full align-items-center" (click)="cePanel.toggle($event)">
                <h3 class="m-0">{{ myPlanCardContent.title }}</h3>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="flex flex-column lg:flex-row lg:align-items-end gap-3 lg:gap-6">
                <div class="flex flex-column flex-1 gap-3">
                    <p class="m-0 text-base line-height-3 text-slate-700">{{ myPlanCardContent.description }}</p>
                    <div class="flex flex-column gap-2">
                        <p class="m-0 text-sm font-medium line-height-3 text-slate-950">
                            {{ myPlanCardContent.devicesLabel }}
                        </p>
                        <ul class="flex flex-wrap gap-3 m-0 p-3 list-none border-round-lg bg-alpha-green-100 lg:align-self-start"
                            data-auto-id="ce-cross-sell-devices">
                            <li *ngFor="let device of myPlanCardContent.devices; trackBy: trackByIndex"
                                class="flex align-items-center gap-2">
                                <img [src]="device.icon" width="18" height="18" alt="">
                                <span class="text-base line-height-3 text-slate-700 white-space-nowrap">
                                    {{ device.label }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div
                    class="flex flex-column md:flex-row md:justify-content-between md:align-items-center lg:flex-column lg:align-items-end gap-3">
                    <p class="m-0 text-base font-medium line-height-3 text-slate-950"
                        data-auto-id="ce-cross-sell-price">
                        Starting at {{ monthlyCost | currency:'USD':'symbol-narrow':'1.2-2' }}/mo
                    </p>
                    <p-button severity="primary" class="w-full md:w-19rem" styleClass="w-full text-base"
                        data-auto-id="ce-cross-sell-add-coverage-button" [rounded]="true"
                        [label]="myPlanCardContent.buttonLabel" (click)="learnAboutOffer()">
                    </p-button>
                </div>
            </div>
        </ng-template>
    </p-panel>
</div>